import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-dropdown-wrapper" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon_button = _resolveComponent("f-icon-button")!
  const _component_f_menu = _resolveComponent("f-menu")!
  const _component_f_dropdown = _resolveComponent("f-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_f_dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_f_menu, { items: _ctx.toolbarMenuItems }, {
          item: _withCtx(({ item }) => [
            _createElementVNode("span", {
              onClick: ($event: any) => (_ctx.handleAction(item)),
              class: "action-item"
            }, _toDisplayString(item.label), 9, _hoisted_2)
          ]),
          _: 1
        }, 8, ["items"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_f_icon_button, {
          icon: "ellipses",
          class: "theme-svg",
          onClick: _ctx.toggleMenu
        }, null, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}